import React, { useEffect, useContext, useState } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { DesktopStepper, GenericModal, PaymentSuccessful, Stepper } from '@pinflag/pinflag-ui-kit'
import './Tailwind.css'

import { DataContext } from './context/DataContext'
import { Header } from './components/Header'
import FinalLoader from './components/FinalLoader'
import { useApiPinflag } from './hook/useApiPinflag'
import { useMagento } from './hook/useMagento'
import { useVtex } from './hook/useVtex'
import ShippingOptionRenderer from './components/organism/ShippingOptionRenderer'
import { useShopify } from './hook/useShopify'
import UserForm from './components/UserForm'
import { useCmsAdapter } from './hook/useCmsAdapter'
import { useWoocommerce } from './hook/useWoocommerce'
import { useSocket } from './hook/useSocket'
import { Summary } from './components/Summary'
import { shippingAddressObject } from './helpers/addressParser'
import { abreviatedCheckoutLines } from './helpers/utils'
import AbandonedCartRedirect from './components/organism/AbandonedCartRedirect'
import { getParamsFromUrl } from './utils/urls'
import { createObjectByKeysExistance } from './utils/object'
import { parseFullName } from './utils/string'
import { useAbandonedCart } from './hook/useAbandonedCart'
import getnetApi from './helpers/getnetApi'
import CartSection from './components/CartSection'
import PaymentMethodSelection from './components/PaymentMethodSelection'
import { usePayment } from './hook/payment/usePayment/usePayment'
import { useSteps } from './hook/useSteps'
import { useWebpay } from './hook/payment/gateways/useWebpay'
import { iframeLoadedWoocommerceVtex } from './helpers/iframeLoadedCmsHelper'

const PinmapPro = () => {
  const {
    showFinalLoader,
    steps,
    currentStep,
    setCurrentStep,
    ecommerceInfo,
    companyInfo,
    userInfo,
    setCartNotes,
    setGiftNotes,
    setIsGiftWrapping,
    isSummaryOpen,
    addressInfo,
    cartData,
    isRemoved,
    deletedCheckoutLog,
    pointsData,
    setIsSummaryOpen,
    selectedShippingMethod,
    selectedPaymentMethod,
    configurations,
    setUserInfo,
    setAbandonedCart,
    abandonedCartData,
    setAddressInfo,
    setSteps,
    setClientMetaData,
    isPickup,
    setEmptyCart,
    emptyCart,
    isProccessingPaymentLoader,
    setIsProccessingPaymentLoader,
    isPaymentRedirect,
    setIsPaymentRedirect,
    encryptedMessage,
    setEncryptedMessage,
    isProductSoldOut,
    setIsProductSoldOut
  } = useContext(DataContext)
  const { getCompanyInfo, getPoints, getFinalLoaderInfo } = useApiPinflag()

  const { goToPreviousStep } = useSteps()

  const { logoUrl } = companyInfo
  const { paymentSuccessfulInformation } = usePayment()

  const [isRedirectingToHome, setIsRedirectingToHome] = useState(false)

  const redirectToHome = () => {
    setIsRedirectingToHome(true)
    redirectToHomeMagento()
    redirectToHomeShopify('user action - redirect home')
    redirectToHomeVtex()
  }
  const {
    setInitialInformationMagento,
    acknowledgeIframeMounted,
    redirectToHomeMagento
  } = useMagento()
  const { iframeLoadedVtexIO, setInitialInformationVtex, redirectToHomeVtex } = useVtex()
  const {
    setInitialInformationShopify,
    checkUpdatedCart,
    applyFreeShippingAutomaticDiscount,
    getShopifyConfiguration,
    redirectToHomeShopify,
    redirectToCartShopify
  } = useShopify()
  const {
    setInitialInformationWoocommerce,
    hideWoocommerceSummary,
    continueCheckout,
    handleDiscountCodeWoocommerce
  } = useWoocommerce()
  const { createCheckoutLog, trackingLeak, trackingPinmap } = useCmsAdapter()
  const { upsertAbandonedCart } = useAbandonedCart()
  const [closePinmap, setClosePinmap] = useState(false)
  const [iframeLoaded, setIframeLoaded] = useState(false)
  const [initialInfoReady, setInitialInfoReady] = useState(false)
  const { scrapperClient } = useSocket()
  const isLoaderIframe = new URLSearchParams(document.location.search).get('loaderIframe')
  const isAbandonedCart = new URLSearchParams(document.location.search).get('abandonedCart')
  const paymentRedirect = new URLSearchParams(document.location.search).get('paymentRedirect')

  useWebpay(paymentRedirect)

  const path = window.location.pathname

  const shouldShowSummary = (stepData) => (
    userInfo.isRegistered && (
      (pointsData.localPoints.length === 1 && selectedShippingMethod === 'local-pickup') ||
      stepData.stepId === 1 === 1
    )
  )

  const handleStepClick = (stepData) => {
    if (shouldShowSummary(stepData)) {
      setIsSummaryOpen(true)
    }

    if (stepData.stepId === currentStep - 1) {
      goToPreviousStep()
      hideWoocommerceSummary()
    }
  }

  const getClientMetaData = () => {
    getnetApi.get()
      .then((response) => {
        setClientMetaData(previousState => ({
          ...previousState,
          userAgent: navigator.userAgent,
          ipAddress: response.data.ip
        }))
      })
      .catch(error => {
        console.error('Error fetching IP address:', error)
      })
  }

  const setAbandonedCartInfo = (message) => {
    const { currentUrl } = message

    const decodedParams = getParamsFromUrl(currentUrl)

    decodedParams.names = parseFullName(decodedParams.firstName, decodedParams.lastName)

    const userInfoAbandonedCart = createObjectByKeysExistance(
      ['email', 'names', 'phone', 'rut'],
      decodedParams)

    const addressInfoAbandonedCart = createObjectByKeysExistance(
      ['userAddress', 'region', 'district', 'aditionalInfo'],
      decodedParams)

    setUserInfo(prevState => ({
      ...prevState,
      ...userInfoAbandonedCart
    }))

    setAddressInfo(prevState => ({
      ...prevState,
      ...addressInfoAbandonedCart
    }))
  }

  const handleClose = () => {
    setIsProductSoldOut(false)
    redirectToCartShopify()
  }

  const messageHandlers = {
    'receive-cart-info': (message, origin) => {
      // To prevent loading the cart when the payment is being processed
      if (paymentRedirect) return
      setInitialInformationMagento(message, setInitialInfoReady)
      setInitialInformationVtex(message, setInitialInfoReady)
      setInitialInformationShopify(message, origin, setInitialInfoReady)
      setInitialInformationWoocommerce(message, setInitialInfoReady)
      if (isAbandonedCart) {
        setAbandonedCartInfo(message)
      }
      setIframeLoaded(true)
    },
    'empty-cart': () => setEmptyCart(true),
    'close-pinmap': () => setClosePinmap(true),
    'order-aditional-info': (message) => setCartNotes(message),
    'gift-wrapping': (message) => setIsGiftWrapping(message),
    'gift-aditional-info': (message) => setGiftNotes(message),
    'receive-user-checkout-info': (message) => continueCheckout(message),
    'update-info-cart': (message) => checkUpdatedCart(message),
    'handle-discount-info': (message) => handleDiscountCodeWoocommerce(message),
    'is-ready': (message) => getCompanyInfo(message),
    'iframe-mounted-ack': () => acknowledgeIframeMounted()
  }

  const incomingMessageHandler = async (event) => {
    if (event?.data?.origin) {
      const { message, origin, type } = event.data
      const handler = messageHandlers[type]

      if (handler) {
        handler(message, origin)
      }
    }
  }

  useEffect(() => {
    if (closePinmap && !isRemoved && !showFinalLoader && userInfo.email && cartData.lines.length) {
      trackingLeak({
        causePinmapLeak: 'user action - close window or reload'
      })
      if (ecommerceInfo.cms !== 'shopify') return
      let storeConfig = configurations
      if (!Object.keys(configurations)?.length) storeConfig = getShopifyConfiguration()

      const checkoutData = {
        email: userInfo.email,
        shippingAddress: addressInfo.userAddress
          ? shippingAddressObject(userInfo, addressInfo, storeConfig)
          : undefined,
        lineItems: abreviatedCheckoutLines(cartData.lines)
      }
      if (!deletedCheckoutLog) createCheckoutLog(checkoutData)
    }
  }, [closePinmap])

  useEffect(() => {
    if (ecommerceInfo.cms && companyInfo.companyName) {
      if (ecommerceInfo.cms !== 'shopify') {
        getPoints()
      }
    }
  }, [ecommerceInfo.cms, companyInfo.companyName])

  useEffect(() => {
    window.addEventListener('message', incomingMessageHandler)
    iframeLoadedVtexIO(setInitialInfoReady)
    setTimeout(iframeLoadedWoocommerceVtex(), 1000)
    setAbandonedCart(isAbandonedCart)
    getClientMetaData()
    getCompanyInfo(isAbandonedCart)
    return () => {
      window.removeEventListener('message', incomingMessageHandler)
    }
  }, [isPaymentRedirect])

  useEffect(() => {
    if (
      companyInfo.companyName.length > 0 && initialInfoReady && selectedPaymentMethod !== 'klap'
    ) {
      trackingPinmap()
    }
  }, [companyInfo, initialInfoReady])

  useEffect(() => {
    if (iframeLoaded && ![null, undefined].includes(abandonedCartData.email) && !isAbandonedCart) {
      upsertAbandonedCart(abandonedCartData)
    }
  }, [iframeLoaded])

  useEffect(() => {
    if (initialInfoReady && currentStep === 1 && ecommerceInfo.cms === 'shopify') {
      applyFreeShippingAutomaticDiscount()
    }
  }, [initialInfoReady])

  // Set payment redirect and encrypted message from URL
  useEffect(() => {
    setIsPaymentRedirect(new URLSearchParams(document.location.search).get('paymentRedirect'))
    setEncryptedMessage(new URLSearchParams(document.location.search).get('referenceId'))
  }, [])

  useEffect(() => {
    if (isPaymentRedirect) {
      setCurrentStep(3)
      setIsProccessingPaymentLoader(true)
    }
  }, [isPaymentRedirect])

  useEffect(() => {
    if (isProccessingPaymentLoader) {
      const updatedSteps = [...steps]
      updatedSteps[0].completed = true
      updatedSteps[0].disabled = true
      updatedSteps[1].completed = true
      updatedSteps[1].subSteps[0].completed = true
      updatedSteps[1].subSteps[1].completed = true
      updatedSteps[1].subSteps[2].completed = true
      updatedSteps[2].completed = true
      setSteps(updatedSteps)
      setIsProccessingPaymentLoader(false)
    }
  }, [emptyCart])

  useEffect(() => {
    if (currentStep === 3 || isLoaderIframe) {
      getFinalLoaderInfo()
    }
  }, [currentStep, isLoaderIframe])

  return (
    <Router>
      <Routes>
        <Route path={'/abandoned-cart/'} element={<AbandonedCartRedirect/>} />
      </Routes>
      <div className='h-full small-mobile-container overflow-y-scroll md:overflow-y-hidden pb-28 md:pb-0'>
        {!showFinalLoader && !isLoaderIframe
          ? (
            <div className='md:w-[850px] h-full font-poppins'>
              <div className={`${path === '/abandoned-cart/' && 'hidden'} ${emptyCart && 'hidden md:block'} ${isProccessingPaymentLoader && '!hidden'}`}>
              <Header />
              </div>
              <div className={`md:hidden ${emptyCart && 'hidden'} ${isProccessingPaymentLoader && '!hidden'}`}>
                <Stepper
                  className='mt-3 px-4 md:w-4/6'
                  steps={steps}
                  currentStep={Math.min(currentStep, 3)}
                  onStepClick={handleStepClick}
                  secondaryColor={companyInfo.secondaryColor}
                />
              </div>
              <div className={`hidden md:flex ${isProccessingPaymentLoader && '!hidden'}`}>
                <DesktopStepper
                  className='mt-5 md:mt-0 px-4 md:w-[480px] md:text-[11px] md:ml-5 md:mb-1'
                  steps={steps}
                  currentStep={Math.min(currentStep, 3)}
                  onStepClick={handleStepClick}
                  primaryColor={companyInfo.primaryColor}
                  secondaryColor={companyInfo.secondaryColor}
                />
              </div>
              { emptyCart
                ? (<PaymentSuccessful
                    logoUrl={logoUrl}
                    redirectToHome={redirectToHome}
                    isRedirectingToHome={isRedirectingToHome}
                    name={paymentSuccessfulInformation.name}
                    email={paymentSuccessfulInformation.email}
                    purchaseOrderId={paymentSuccessfulInformation.purchaseOrderId}
                    referenceId={paymentSuccessfulInformation.referenceId}
                  />)
                : (
                <>
                <GenericModal
                  isOpenModal={isProductSoldOut}
                  icon='error'
                  modalTitle='Producto agotado'
                  modalText='Uno de tus productos está agotado. Debes dirigirte al carro.'
                  secondButton='Volver al carro'
                  handleAction={handleClose}
                />
                {currentStep === 1 && <UserForm abandonedCart={isAbandonedCart} />}
                {currentStep === 2 && (isSummaryOpen ? <Summary /> : <ShippingOptionRenderer />)}
                {currentStep === 3 &&
                  <PaymentMethodSelection
                    scrapperClient={scrapperClient}
                    isPaymentRedirect={isPaymentRedirect}
                    encryptedMessage={encryptedMessage}
                    />
                }
                {currentStep === 4 && <PaymentSuccessful
                  logoUrl={logoUrl}
                  redirectToHome={redirectToHome}
                  isRedirectingToHome={isRedirectingToHome}
                  name={paymentSuccessfulInformation.name}
                  email={paymentSuccessfulInformation.email}
                  purchaseOrderId={paymentSuccessfulInformation.purchaseOrderId}
                  referenceId={paymentSuccessfulInformation.referenceId}
                />}
                {!isPickup && (
                  <div className='md:hidden pb-20 bg-slate-100 pt-2'>
                    <CartSection setIsOpen={() => {}} className='p-4' />
                    <div className='md:hidden flex justify-center pt-2 text-sm text-slate-300 mb-[3rem]'>
                      100% Seguro + Rápido y Fácil. Powered by
                      <a
                        href='https://pinflag.cl'
                        target='_blank'
                        style={{ textDecoration: 'none' }}
                        rel='noreferrer'
                      >
                        <span className='font-bold'>&nbsp;Pinflag</span>
                      </a>
                    </div>
                  </div>
                )}
                </>
                  )
              }
            </div>
            )
          : (
            <FinalLoader />
            )}
      </div>
    </Router>
  )
}

export default PinmapPro
